import PropTypes from 'prop-types';
import { formatAmount } from 'Shared/util/formatters';
import { translateColumns } from 'Shared/util/translations';
import DataTable, { ColumnTypes } from 'Shared/components/tables/data-table';


const columns = [{
  title: 'from_credit_volume',
  key: 'fromCreditVolume',
  type: ColumnTypes.Amount,
  formatter: (d) => formatAmount(d),
}, {
  title: 'to_credit_volume',
  key: 'toCreditVolume',
  type: ColumnTypes.Amount,
  formatter: (d) => formatAmount(d),
}, {
  title: 'price_percent',
  key: 'price',
  type: ColumnTypes.Amount,
  formatter: (d) => formatAmount(d),
}, {
  title: 'number_of_approved_guarantors',
  key: 'approvedGuarantors',
}];


const PricingMatrixTable = ({
  rows,
  translations,
}) => (
  <DataTable
    columns={translateColumns(columns, translations)}
    rows={rows}
  />
);

PricingMatrixTable.propTypes = {
  rows: PropTypes.array.isRequired,
  translations: PropTypes.object.isRequired,
};

export default PricingMatrixTable;
